import { DatabaseFieldType } from '@databases/types/database';
import { isNonEmptyJiraIssueValue } from '@databases/utils/database/field-types/jiraIssue';
import React, { FunctionComponent, useMemo, useRef } from 'react';

import { PopoverEdit } from '../PopoverEdit';
import { EditComponentProps } from '../types';

import JiraIssueSelect from './JiraIssueSelect';
import { JiraIssuePopoverValue } from './JiraIssueValue';

const JiraIssueValuePopoverEdit: FunctionComponent<
  EditComponentProps<DatabaseFieldType.JIRA_ISSUE>
> = ({
  field,
  value,
  onChange,
  onFocus,
  onBlur,
  autoFocus,
  isDefaultValue,
  isFilterValueEdit,
}) => {
  const resolvedValues = useMemo(
    () =>
      value.map((v) =>
        isNonEmptyJiraIssueValue(v) ? { ...v, serverId: field.settings.jiraServerId } : v
      ),
    [field.settings.jiraServerId, value]
  );
  const isRenderedInSidePanel = isDefaultValue || isFilterValueEdit;

  const isMulti = field.settings.multi || resolvedValues.length > 1;
  const addDataSectionRef = useRef<HTMLDivElement | null>(null);

  const UserSelectAddDataSection = (
    <div ref={addDataSectionRef}>
      <JiraIssueSelect
        cloudId={field.settings.cloudId}
        serverId={field.settings.jiraServerId}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={autoFocus}
        resolvedValues={resolvedValues}
        isRenderedInSidePanel={isRenderedInSidePanel}
      />
    </div>
  );
  const CurrentDataSection = (
    <>
      {resolvedValues.map((rValue) => {
        return (
          <JiraIssuePopoverValue
            key={rValue._id}
            resolvedValue={rValue}
            resolvedValues={resolvedValues}
            autoFocus={autoFocus}
            onChange={onChange}
            field={field}
            isLinkPreview
            addDataSectionRef={addDataSectionRef}
          />
        );
      })}
    </>
  );

  return (
    <PopoverEdit
      isMultiSelect={isMulti}
      hasCurrentData={value.length > 0}
      currentDataSection={CurrentDataSection}
      addDataSection={UserSelectAddDataSection}
      isRenderedInSidePanel={isRenderedInSidePanel}
      fieldWidth={field.width}
    />
  );
};

export default JiraIssueValuePopoverEdit;
